import * as types from './types'
import DirectusApi from '../../lib/directus.api'
import { LocationChoiceType } from '../../config/types'


export const loadDistrictsOfState = ({ stateId, locationTypes }: { stateId: string, locationTypes: LocationChoiceType }) =>
  async (dispatch: Function, state: Function) => {
    let theLocationTypes = locationTypes

    if (!Array.isArray(locationTypes)) {
      theLocationTypes = [locationTypes]
    }

    const sort = 'title'

    const filter =
    {
      _and: [
        {
          state: {
            id: {
              _eq: stateId
            }
          }
        },
        {
          addresses: {
            id: {
              _nempty: true
            },
            ...(theLocationTypes && theLocationTypes.length && {
              _or: theLocationTypes.map(lt => ({
                locations: {
                  location_Types: {
                    _contains: lt
                  }
                }
              }))
            })
          }
        },
      ],
    }

    try {
      const { data: { data: result } } = await DirectusApi.get('/items/districts', {
        params: {
          sort,
          filter,
        }
      })
      dispatch({
        type: types.SET_DISTRICTS,
        districts: result
      })
      return result
    } catch (reason) {
      throw new Error(reason.message)
    }
  }

export const loadLocationsOfDistrict = ({ districtId, locationTypes }: { districtId: string, locationTypes: LocationChoiceType }) => async (dispatch: Function, state: Function) => {
  // if (!districtId) return Promise.reject()
  let theLocationTypes = locationTypes

  if (!Array.isArray(locationTypes)) {
    theLocationTypes = [locationTypes]
  }

  const sort = 'sort'
  const filter = {
    address: {
      district: {
        // id: {
        '_eq': districtId
        // }
      }
    },
    ...(theLocationTypes && theLocationTypes.length && {
      _or: theLocationTypes.map(lt => ({
        location_types: {
          _contains: lt
        }
      }))
    })
  }

  try {
    const { data: { data: result } } = await DirectusApi.get('/items/locations', {
      params: {
        sort,
        fields: '*.*',
        filter
      }
    })
    dispatch({
      type: types.SET_LOCATIONS,
      locations: result
    })
    return result
  } catch (reason) {
    throw new Error(reason.message)
  }
}